import { render, staticRenderFns } from "./ChoicePublishers.vue?vue&type=template&id=75a23054&scoped=true&"
import script from "./ChoicePublishers.vue?vue&type=script&lang=js&"
export * from "./ChoicePublishers.vue?vue&type=script&lang=js&"
import style0 from "./ChoicePublishers.vue?vue&type=style&index=0&id=75a23054&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75a23054",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
installComponents(component, {VRadio,VRadioGroup})
